import React, { useEffect } from 'react';
import { useLocation, BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react"

import HomeCopy from './pages/HomeCopy';
import ScrollToHash from './components/ScrollToHash';
import Corporation from './pages/Corporation';
import Professor from './pages/Professor';
import Research from './pages/Research';
import Project from './pages/Project';
import Chapter from './pages/Chapter';
import Leadership from './pages/Leadership';
import ContactUs from './pages/ContactUs';
import Verify from './pages/Verify';
import RedirectToHome from './components/RedirectToHome';

import Workshops from './pages/Workshops';

// import GrantHome from './pages/grant/GrantHome';
// import Editor from './pages/grant/Editor';
// import TemplateBuilder from './pages/grant/TemplateBuilder';
// import Export from './pages/grant/Export';

const App = () => {
  return (
    <Router>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<HomeCopy />} />
        <Route path="/corporation" element={<Corporation />} />
        <Route path="/professor" element={<Professor />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/projects" element={<Research />} />
        <Route path="/projects/:slug" element={<Project />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/chapters/:slug" element={<Chapter />} />
        
        <Route path='/workshops' element={<Workshops />}/>

        <Route path="*" element={<RedirectToHome />} />
      </Routes>
    </Router>
  );
}

export default App;